export default __webpack_public_path__ + "assets/images/pay_second.f82e21.png";